import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.observer = new IntersectionObserver(
      ([entry]) => this.element.classList.toggle('stuck', entry.intersectionRatio < 1),
      { threshold: [1], rootMargin: '0px 0px -1px 0px' }
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer.disconnect()
  }
}
